export const searchableData = [
    {
        name: 'application',
        action: '/applications',
    },
    {
        name: 'document',
        action: '/documents',
    },
    {
        name: 'profile',
        action: '/profile',
    },
    {
        name: 'dashboard',
        action: '/dashboard',
    },
    {
        name: 'support',
        action: '/contact-us',
    },
    {
        name: 'faqs',
        action: '/faq',
    },
    {
        name: 'contact-us',
        action: '/contact-us',
    },
]